import type { Pipeline } from './types';

// Major international oil and gas pipelines
// Sources: Global Energy Monitor, EIA, public domain geographic data
export const PIPELINES: Pipeline[] = [
  // ===== MAJOR OIL PIPELINES =====

  // North America
  {
    id: 'keystone',
    name: 'Keystone Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-104.05, 50.95], [-104.0, 49.0], [-101.5, 46.8], [-97.5, 44.4], [-97.0, 41.2], [-95.9, 36.1], [-95.0, 29.8]],
    capacity: '590,000 bpd',
    length: '3,456 km',
    operator: 'TC Energy',
    countries: ['Canada', 'USA'],
  },
  {
    id: 'dakota-access',
    name: 'Dakota Access Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-103.5, 47.5], [-100.8, 46.8], [-97.0, 45.5], [-96.0, 43.5], [-93.5, 41.5], [-91.0, 40.5]],
    capacity: '570,000 bpd',
    length: '1,886 km',
    operator: 'Energy Transfer',
    countries: ['USA'],
  },
  {
    id: 'trans-mountain',
    name: 'Trans Mountain Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-114.1, 53.5], [-117.5, 52.9], [-119.3, 52.1], [-121.0, 50.7], [-122.8, 49.3]],
    capacity: '890,000 bpd',
    length: '1,150 km',
    operator: 'Trans Mountain Corp',
    countries: ['Canada'],
  },
  {
    id: 'colonial',
    name: 'Colonial Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-95.4, 29.8], [-93.2, 30.2], [-90.1, 30.0], [-86.8, 30.7], [-84.4, 33.8], [-80.8, 32.1], [-78.6, 35.8], [-77.0, 38.9], [-74.0, 40.7]],
    capacity: '2.5 million bpd',
    length: '8,850 km',
    operator: 'Colonial Pipeline Co',
    countries: ['USA'],
  },
  {
    id: 'enbridge-line5',
    name: 'Enbridge Line 5',
    type: 'oil',
    status: 'operating',
    points: [[-89.0, 46.8], [-86.0, 45.8], [-84.5, 45.5], [-83.0, 43.0], [-82.5, 42.3]],
    capacity: '540,000 bpd',
    length: '1,038 km',
    operator: 'Enbridge',
    countries: ['USA', 'Canada'],
  },
  {
    id: 'permian-gulf',
    name: 'Permian Express Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-102.5, 32.0], [-100.5, 31.5], [-98.0, 30.0], [-96.5, 29.0], [-95.0, 29.5]],
    capacity: '480,000 bpd',
    length: '830 km',
    operator: 'Energy Transfer',
    countries: ['USA'],
  },
  {
    id: 'capline',
    name: 'Capline Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-89.1, 30.0], [-90.5, 32.3], [-90.2, 35.1], [-89.0, 38.6]],
    capacity: '1.2 million bpd',
    length: '1,017 km',
    operator: 'Marathon/Plains',
    countries: ['USA'],
  },
  {
    id: 'seaway',
    name: 'Seaway Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-97.0, 36.0], [-96.0, 33.0], [-95.5, 30.5], [-95.0, 29.5]],
    capacity: '850,000 bpd',
    length: '800 km',
    operator: 'Enterprise/Enbridge',
    countries: ['USA'],
  },
  {
    id: 'explorer',
    name: 'Explorer Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-95.5, 29.8], [-95.0, 32.0], [-94.5, 35.0], [-93.0, 38.5], [-90.5, 41.5], [-88.0, 41.9]],
    capacity: '660,000 bpd',
    length: '2,900 km',
    operator: 'Explorer Pipeline',
    countries: ['USA'],
  },
  {
    id: 'enbridge-mainline',
    name: 'Enbridge Mainline',
    type: 'oil',
    status: 'operating',
    points: [[-114.1, 53.5], [-110.0, 53.5], [-105.0, 52.0], [-97.0, 49.9], [-92.0, 48.0], [-86.0, 46.5], [-83.5, 42.5]],
    capacity: '2.85 million bpd',
    length: '5,353 km',
    operator: 'Enbridge',
    countries: ['Canada', 'USA'],
  },

  // More US Oil Pipelines
  {
    id: 'plantation',
    name: 'Plantation Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-90.1, 30.0], [-87.0, 30.5], [-84.5, 33.7], [-81.1, 34.0], [-79.0, 35.5], [-77.5, 37.5]],
    capacity: '660,000 bpd',
    length: '4,800 km',
    operator: 'Kinder Morgan',
    countries: ['USA'],
  },
  {
    id: 'mid-valley',
    name: 'Mid-Valley Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-90.0, 29.9], [-89.5, 32.0], [-86.0, 36.1], [-85.7, 38.2], [-83.0, 39.1], [-81.5, 41.5]],
    capacity: '320,000 bpd',
    length: '1,400 km',
    operator: 'Sunoco',
    countries: ['USA'],
  },
  {
    id: 'gulf-coast-pipeline',
    name: 'Gulf Coast Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-97.0, 36.0], [-97.5, 33.5], [-96.0, 30.5], [-95.0, 29.5]],
    capacity: '700,000 bpd',
    length: '780 km',
    operator: 'Enterprise Products',
    countries: ['USA'],
  },
  {
    id: 'flanagan-south',
    name: 'Flanagan South Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-88.0, 41.5], [-90.5, 39.5], [-94.0, 37.0], [-97.0, 36.0]],
    capacity: '600,000 bpd',
    length: '950 km',
    operator: 'Enbridge',
    countries: ['USA'],
  },
  {
    id: 'spearhead',
    name: 'Spearhead Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-88.0, 41.5], [-90.0, 39.8], [-94.5, 37.0], [-97.0, 36.0]],
    capacity: '193,000 bpd',
    length: '1,060 km',
    operator: 'Enbridge',
    countries: ['USA'],
  },

  // Russia/Europe
  {
    id: 'druzhba',
    name: 'Druzhba Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[52.3, 54.7], [44.0, 53.2], [37.6, 52.3], [32.0, 52.4], [24.0, 52.2], [21.0, 52.2], [14.4, 52.5]],
    capacity: '1.2 million bpd',
    length: '5,327 km',
    operator: 'Transneft',
    countries: ['Russia', 'Belarus', 'Poland', 'Germany', 'Ukraine', 'Czech Republic', 'Hungary'],
  },
  {
    id: 'btc',
    name: 'Baku-Tbilisi-Ceyhan (BTC)',
    type: 'oil',
    status: 'operating',
    points: [[49.9, 40.4], [47.5, 41.3], [44.8, 41.7], [41.6, 41.6], [36.8, 39.5], [35.9, 37.0]],
    capacity: '1.2 million bpd',
    length: '1,768 km',
    operator: 'BP',
    countries: ['Azerbaijan', 'Georgia', 'Turkey'],
  },
  {
    id: 'cpc',
    name: 'Caspian Pipeline Consortium',
    type: 'oil',
    status: 'operating',
    points: [[53.0, 46.9], [49.0, 46.0], [45.5, 45.5], [40.0, 45.0], [37.4, 45.0]],
    capacity: '1.4 million bpd',
    length: '1,510 km',
    operator: 'CPC',
    countries: ['Kazakhstan', 'Russia'],
  },

  // Middle East
  {
    id: 'east-west',
    name: 'East-West Pipeline (Petroline)',
    type: 'oil',
    status: 'operating',
    points: [[50.1, 26.3], [47.0, 26.0], [44.0, 25.5], [41.0, 24.0], [38.5, 22.5]],
    capacity: '5 million bpd',
    length: '1,200 km',
    operator: 'Saudi Aramco',
    countries: ['Saudi Arabia'],
  },
  {
    id: 'sumed',
    name: 'SUMED Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[33.0, 29.0], [31.2, 30.0], [29.9, 31.2]],
    capacity: '2.5 million bpd',
    length: '320 km',
    operator: 'SUMED',
    countries: ['Egypt'],
  },
  {
    id: 'kirkuk-ceyhan',
    name: 'Kirkuk-Ceyhan Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[44.4, 35.5], [42.5, 36.5], [40.0, 37.0], [37.0, 37.5], [35.9, 37.0]],
    capacity: '1.6 million bpd',
    length: '970 km',
    operator: 'BOTAS/SOMO',
    countries: ['Iraq', 'Turkey'],
  },
  {
    id: 'habshan-fujairah',
    name: 'Habshan-Fujairah Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[53.6, 23.9], [55.0, 24.8], [56.2, 25.1], [56.4, 25.1]],
    capacity: '1.5 million bpd',
    length: '370 km',
    operator: 'ADNOC',
    countries: ['UAE'],
  },
  {
    id: 'abqaiq-yanbu',
    name: 'Abqaiq-Yanbu Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[49.7, 25.9], [47.0, 26.0], [44.0, 25.0], [41.0, 24.0], [38.0, 24.0]],
    capacity: '3 million bpd',
    length: '1,170 km',
    operator: 'Saudi Aramco',
    countries: ['Saudi Arabia'],
  },
  {
    id: 'iran-turkey',
    name: 'Iran-Turkey Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[48.0, 38.5], [45.0, 38.2], [43.5, 37.0], [42.0, 37.2]],
    capacity: '14 bcm/year',
    length: '2,577 km',
    operator: 'NIGC/BOTAS',
    countries: ['Iran', 'Turkey'],
  },
  {
    id: 'igat-1',
    name: 'IGAT-1 (Iranian Gas Trunkline)',
    type: 'gas',
    status: 'operating',
    points: [[52.5, 27.5], [51.5, 30.5], [50.5, 32.5], [48.5, 35.5], [48.0, 38.0]],
    capacity: '15 bcm/year',
    length: '1,100 km',
    operator: 'NIGC',
    countries: ['Iran'],
  },
  {
    id: 'south-pars-assaluyeh',
    name: 'South Pars Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[52.0, 26.0], [52.5, 27.5], [52.0, 29.5], [51.5, 31.0]],
    capacity: '40 bcm/year',
    length: '900 km',
    operator: 'NIGC',
    countries: ['Iran'],
  },
  {
    id: 'basra-gas',
    name: 'Basra Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[47.8, 30.5], [47.0, 31.5], [46.0, 32.5], [45.0, 33.0]],
    capacity: '8 bcm/year',
    length: '300 km',
    operator: 'Basra Gas Company',
    countries: ['Iraq'],
  },
  {
    id: 'trans-israel',
    name: 'Trans-Israel Pipeline (Eilat-Ashkelon)',
    type: 'oil',
    status: 'operating',
    points: [[34.9, 29.6], [35.0, 30.5], [34.8, 31.0], [34.6, 31.6]],
    capacity: '600,000 bpd',
    length: '254 km',
    operator: 'EAPC',
    countries: ['Israel'],
  },
  {
    id: 'leviathan-ashdod',
    name: 'Leviathan Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[34.0, 33.0], [34.5, 32.5], [34.6, 31.8]],
    capacity: '12 bcm/year',
    length: '120 km',
    operator: 'Noble Energy',
    countries: ['Israel'],
  },
  // More Middle East Oil
  {
    id: 'ain-dar-abqaiq',
    name: 'Ain Dar-Abqaiq Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[49.2, 25.4], [49.7, 25.9]],
    capacity: '2 million bpd',
    length: '50 km',
    operator: 'Saudi Aramco',
    countries: ['Saudi Arabia'],
  },
  {
    id: 'kuwait-oil-export',
    name: 'Kuwait Oil Export Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[47.5, 29.0], [48.2, 29.4], [48.0, 29.0]],
    capacity: '2 million bpd',
    length: '120 km',
    operator: 'KOC',
    countries: ['Kuwait'],
  },
  {
    id: 'abu-dhabi-crude',
    name: 'Abu Dhabi Crude Oil Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[54.0, 24.0], [54.5, 24.5], [55.5, 25.0]],
    capacity: '1.8 million bpd',
    length: '200 km',
    operator: 'ADNOC',
    countries: ['UAE'],
  },

  // Africa
  {
    id: 'chad-cameroon',
    name: 'Chad-Cameroon Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[16.8, 10.0], [14.5, 7.5], [12.5, 5.5], [10.0, 4.0]],
    capacity: '250,000 bpd',
    length: '1,070 km',
    operator: 'COTCO',
    countries: ['Chad', 'Cameroon'],
  },
  {
    id: 'nigeria-bonny',
    name: 'Trans-Niger Pipeline (Bonny)',
    type: 'oil',
    status: 'operating',
    points: [[6.0, 5.5], [6.5, 5.0], [7.2, 4.5]],
    capacity: '600,000 bpd',
    length: '250 km',
    operator: 'Shell',
    countries: ['Nigeria'],
  },
  {
    id: 'forcados-escravos',
    name: 'Forcados-Escravos Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[5.3, 5.4], [5.5, 5.2], [5.8, 5.0]],
    capacity: '400,000 bpd',
    length: '150 km',
    operator: 'Shell/Chevron',
    countries: ['Nigeria'],
  },
  {
    id: 'angola-offshore',
    name: 'Angola Offshore Export Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[12.0, -6.5], [12.5, -7.0], [13.2, -8.8]],
    capacity: '800,000 bpd',
    length: '300 km',
    operator: 'Sonangol',
    countries: ['Angola'],
  },
  {
    id: 'cameroon-lobe',
    name: 'Cameroon Lobe Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[9.0, 2.5], [9.2, 3.0], [9.7, 4.0]],
    capacity: '100,000 bpd',
    length: '180 km',
    operator: 'SNH',
    countries: ['Cameroon'],
  },
  {
    id: 'sudan-port',
    name: 'Greater Nile Oil Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[30.0, 9.5], [32.0, 13.0], [34.0, 16.0], [37.2, 19.6]],
    capacity: '500,000 bpd',
    length: '1,610 km',
    operator: 'GNPOC',
    countries: ['South Sudan', 'Sudan'],
  },

  // More Russia Oil
  {
    id: 'baltic-pipeline',
    name: 'Baltic Pipeline System (BPS)',
    type: 'oil',
    status: 'operating',
    points: [[50.0, 55.0], [40.0, 58.0], [32.0, 59.5], [28.0, 59.9]],
    capacity: '1.5 million bpd',
    length: '2,350 km',
    operator: 'Transneft',
    countries: ['Russia'],
  },
  {
    id: 'bps-2',
    name: 'Baltic Pipeline System 2 (BPS-2)',
    type: 'oil',
    status: 'operating',
    points: [[42.0, 56.5], [35.0, 58.0], [30.0, 59.0], [28.5, 59.5]],
    capacity: '600,000 bpd',
    length: '1,000 km',
    operator: 'Transneft',
    countries: ['Russia'],
  },
  {
    id: 'northern-lights',
    name: 'Surgut-Polotsk Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[73.4, 61.2], [68.0, 60.0], [55.0, 57.0], [40.0, 55.0], [28.0, 55.5]],
    capacity: '900,000 bpd',
    length: '3,500 km',
    operator: 'Transneft',
    countries: ['Russia', 'Belarus'],
  },
  {
    id: 'russia-novorossiysk',
    name: 'Tikhoretsk-Novorossiysk Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[40.0, 45.5], [38.5, 45.0], [37.8, 44.7]],
    capacity: '1 million bpd',
    length: '350 km',
    operator: 'Transneft',
    countries: ['Russia'],
  },

  // More Asia Oil
  {
    id: 'west-east-oil',
    name: 'West-East Oil Pipeline (China)',
    type: 'oil',
    status: 'operating',
    points: [[87.6, 43.8], [95.0, 40.0], [105.0, 38.5], [114.0, 36.0], [120.0, 34.0]],
    capacity: '400,000 bpd',
    length: '4,200 km',
    operator: 'CNPC',
    countries: ['China'],
  },
  {
    id: 'shenyang-dalian',
    name: 'Shenyang-Dalian Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[123.4, 41.8], [122.5, 40.5], [121.6, 38.9]],
    capacity: '300,000 bpd',
    length: '450 km',
    operator: 'CNPC',
    countries: ['China'],
  },
  {
    id: 'lanzhou-chengdu',
    name: 'Lanzhou-Chengdu Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[103.8, 36.0], [104.0, 33.0], [104.1, 30.7]],
    capacity: '200,000 bpd',
    length: '880 km',
    operator: 'CNPC',
    countries: ['China'],
  },

  // Asia
  {
    id: 'espo',
    name: 'Eastern Siberia-Pacific Ocean (ESPO)',
    type: 'oil',
    status: 'operating',
    points: [[114.5, 56.5], [120.0, 55.0], [126.0, 52.0], [131.0, 48.5], [133.0, 47.0]],
    capacity: '1.6 million bpd',
    length: '4,857 km',
    operator: 'Transneft',
    countries: ['Russia'],
  },
  {
    id: 'mohe-daqing',
    name: 'Mohe-Daqing Pipeline (ESPO Spur)',
    type: 'oil',
    status: 'operating',
    points: [[124.0, 52.0], [125.0, 50.0], [126.0, 48.5], [125.1, 46.6]],
    capacity: '600,000 bpd',
    length: '960 km',
    operator: 'CNPC',
    countries: ['Russia', 'China'],
  },
  {
    id: 'kazakhstan-china',
    name: 'Kazakhstan-China Oil Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[53.0, 47.1], [60.0, 45.5], [68.0, 43.5], [75.0, 43.0], [82.0, 44.2], [87.6, 43.8]],
    capacity: '400,000 bpd',
    length: '2,228 km',
    operator: 'KazTransOil/CNPC',
    countries: ['Kazakhstan', 'China'],
  },
  {
    id: 'china-myanmar',
    name: 'China-Myanmar Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[93.2, 20.1], [96.5, 22.0], [98.5, 24.0], [100.5, 25.0], [102.7, 25.0]],
    capacity: '440,000 bpd',
    length: '771 km',
    operator: 'CNPC',
    countries: ['Myanmar', 'China'],
  },

  // ===== MAJOR GAS PIPELINES =====

  // Russia/Europe
  {
    id: 'turkstream',
    name: 'TurkStream',
    type: 'gas',
    status: 'operating',
    points: [[38.5, 44.6], [35.0, 43.5], [31.0, 42.5], [29.0, 41.3]],
    capacity: '31.5 bcm/year',
    length: '930 km',
    operator: 'Gazprom',
    countries: ['Russia', 'Turkey'],
  },
  {
    id: 'blue-stream',
    name: 'Blue Stream',
    type: 'gas',
    status: 'operating',
    points: [[37.8, 44.6], [35.5, 43.0], [33.0, 42.0], [31.0, 41.5]],
    capacity: '16 bcm/year',
    length: '1,213 km',
    operator: 'Gazprom/BOTAS',
    countries: ['Russia', 'Turkey'],
  },
  {
    id: 'yamal-europe',
    name: 'Yamal-Europe Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[73.5, 67.5], [66.0, 64.0], [55.0, 60.0], [45.0, 57.0], [32.0, 55.0], [24.0, 53.0], [17.0, 52.5], [14.0, 52.5]],
    capacity: '33 bcm/year',
    length: '4,196 km',
    operator: 'Gazprom',
    countries: ['Russia', 'Belarus', 'Poland', 'Germany'],
  },
  {
    id: 'trans-adriatic',
    name: 'Trans Adriatic Pipeline (TAP)',
    type: 'gas',
    status: 'operating',
    points: [[20.1, 39.6], [19.5, 40.5], [18.0, 40.8], [16.5, 41.0]],
    capacity: '10 bcm/year',
    length: '878 km',
    operator: 'TAP AG',
    countries: ['Greece', 'Albania', 'Italy'],
  },
  {
    id: 'tanap',
    name: 'Trans-Anatolian Pipeline (TANAP)',
    type: 'gas',
    status: 'operating',
    points: [[42.0, 41.6], [39.0, 40.0], [35.0, 39.0], [32.0, 38.5], [29.0, 39.5], [26.5, 40.5]],
    capacity: '16 bcm/year',
    length: '1,850 km',
    operator: 'TANAP',
    countries: ['Azerbaijan', 'Georgia', 'Turkey'],
  },
  {
    id: 'europipe-i',
    name: 'Europipe I',
    type: 'gas',
    status: 'operating',
    points: [[2.5, 58.5], [4.0, 56.0], [6.0, 54.5], [8.5, 54.0]],
    capacity: '18 bcm/year',
    length: '620 km',
    operator: 'Gassco',
    countries: ['Norway', 'Germany'],
  },
  {
    id: 'europipe-ii',
    name: 'Europipe II',
    type: 'gas',
    status: 'operating',
    points: [[7.0, 60.0], [5.0, 57.5], [4.5, 55.5], [6.5, 54.0], [8.5, 53.5]],
    capacity: '24 bcm/year',
    length: '658 km',
    operator: 'Gassco',
    countries: ['Norway', 'Germany'],
  },
  {
    id: 'langeled',
    name: 'Langeled Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[2.0, 61.5], [1.0, 59.0], [0.0, 56.5], [0.5, 53.5]],
    capacity: '25.5 bcm/year',
    length: '1,200 km',
    operator: 'Gassco',
    countries: ['Norway', 'UK'],
  },
  {
    id: 'interconnector',
    name: 'Interconnector (IUK)',
    type: 'gas',
    status: 'operating',
    points: [[1.3, 51.4], [2.0, 51.3], [3.2, 51.3]],
    capacity: '20 bcm/year',
    length: '235 km',
    operator: 'Interconnector Ltd',
    countries: ['UK', 'Belgium'],
  },
  {
    id: 'bbl-pipeline',
    name: 'BBL Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[1.7, 52.8], [3.5, 53.0], [5.0, 53.5]],
    capacity: '15 bcm/year',
    length: '230 km',
    operator: 'BBL Company',
    countries: ['UK', 'Netherlands'],
  },
  {
    id: 'balticconnector',
    name: 'Balticconnector',
    type: 'gas',
    status: 'operating',
    points: [[24.8, 59.4], [24.5, 59.5], [24.7, 59.8]],
    capacity: '7.2 bcm/year',
    length: '77 km',
    operator: 'Elering/Baltic Connector',
    countries: ['Estonia', 'Finland'],
  },
  {
    id: 'brotherhood',
    name: 'Brotherhood Pipeline System',
    type: 'gas',
    status: 'operating',
    points: [[76.0, 66.5], [70.0, 63.0], [60.0, 58.0], [50.0, 55.0], [40.0, 52.0], [32.0, 50.5], [24.0, 49.0], [18.0, 48.5]],
    capacity: '100+ bcm/year',
    length: '4,500 km',
    operator: 'Gazprom',
    countries: ['Russia', 'Ukraine', 'Slovakia', 'Czech Republic'],
  },
  {
    id: 'opal',
    name: 'OPAL Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[12.1, 54.1], [12.5, 52.5], [13.0, 51.0], [14.5, 50.0]],
    capacity: '36 bcm/year',
    length: '470 km',
    operator: 'OPAL Gastransport',
    countries: ['Germany', 'Czech Republic'],
  },
  {
    id: 'nel',
    name: 'NEL Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[12.1, 54.1], [11.0, 53.8], [9.5, 53.5], [8.0, 53.2]],
    capacity: '20 bcm/year',
    length: '440 km',
    operator: 'NEL Gastransport',
    countries: ['Germany'],
  },

  // Middle East
  {
    id: 'dolphin',
    name: 'Dolphin Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[51.5, 25.9], [52.0, 25.3], [54.4, 24.5]],
    capacity: '3.2 bcf/day',
    length: '364 km',
    operator: 'Dolphin Energy',
    countries: ['Qatar', 'UAE'],
  },
  {
    id: 'arab-gas',
    name: 'Arab Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[34.4, 31.5], [35.5, 32.0], [36.3, 33.9], [36.0, 35.5], [36.2, 36.6]],
    capacity: '10 bcm/year',
    length: '1,200 km',
    operator: 'Various',
    countries: ['Egypt', 'Jordan', 'Syria', 'Lebanon'],
  },

  // Central Asia
  {
    id: 'central-asia-china',
    name: 'Central Asia-China Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[62.5, 39.0], [66.0, 41.3], [69.0, 41.0], [75.0, 40.5], [80.0, 40.0], [87.5, 44.0]],
    capacity: '55 bcm/year',
    length: '1,833 km',
    operator: 'CNPC',
    countries: ['Turkmenistan', 'Uzbekistan', 'Kazakhstan', 'China'],
  },
  {
    id: 'power-of-siberia',
    name: 'Power of Siberia',
    type: 'gas',
    status: 'operating',
    points: [[118.0, 62.0], [122.0, 58.0], [127.5, 52.0], [130.0, 48.5], [127.5, 45.8]],
    capacity: '38 bcm/year',
    length: '3,000 km',
    operator: 'Gazprom',
    countries: ['Russia', 'China'],
  },

  // India
  {
    id: 'hbj',
    name: 'HBJ Pipeline (Hazira-Vijaipur-Jagdishpur)',
    type: 'gas',
    status: 'operating',
    points: [[72.6, 21.1], [74.5, 22.5], [76.0, 23.5], [79.0, 24.0], [82.0, 26.0], [83.0, 26.8]],
    capacity: '33 mcm/day',
    length: '2,700 km',
    operator: 'GAIL',
    countries: ['India'],
  },
  {
    id: 'dahej-uran',
    name: 'Dahej-Uran Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[72.6, 21.7], [72.8, 20.5], [72.9, 19.0]],
    capacity: '20 mcm/day',
    length: '500 km',
    operator: 'GAIL',
    countries: ['India'],
  },
  {
    id: 'east-india-pipeline',
    name: 'East India Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[81.6, 16.5], [83.0, 18.0], [85.8, 20.3], [87.0, 22.5], [88.3, 22.6]],
    capacity: '16 mcm/day',
    length: '1,400 km',
    operator: 'GAIL',
    countries: ['India'],
  },

  // Southeast Asia
  {
    id: 'trans-thailand-malaysia',
    name: 'Trans-Thailand-Malaysia Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[101.0, 6.5], [101.5, 5.5], [103.0, 4.5], [103.8, 1.3]],
    capacity: '15 bcm/year',
    length: '1,100 km',
    operator: 'PTT/Petronas',
    countries: ['Thailand', 'Malaysia', 'Singapore'],
  },
  {
    id: 'south-sumatra-west-java',
    name: 'South Sumatra-West Java Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[104.8, -2.9], [105.5, -4.5], [106.0, -5.5], [106.8, -6.2]],
    capacity: '8 bcm/year',
    length: '500 km',
    operator: 'Pertamina',
    countries: ['Indonesia'],
  },

  // Africa
  {
    id: 'west-african-gas',
    name: 'West African Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[5.5, 4.3], [2.5, 6.1], [1.2, 6.2], [0.2, 5.6]],
    capacity: '5 bcm/year',
    length: '678 km',
    operator: 'WAPCo',
    countries: ['Nigeria', 'Benin', 'Togo', 'Ghana'],
  },
  {
    id: 'greenstream',
    name: 'Greenstream Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[12.5, 32.9], [12.0, 35.0], [11.5, 37.0], [15.0, 38.2]],
    capacity: '11 bcm/year',
    length: '520 km',
    operator: 'Greenstream BV',
    countries: ['Libya', 'Italy'],
  },
  {
    id: 'medgaz',
    name: 'Medgaz Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[-0.6, 35.9], [-1.5, 36.5], [-2.5, 36.8]],
    capacity: '8 bcm/year',
    length: '210 km',
    operator: 'Medgaz SA',
    countries: ['Algeria', 'Spain'],
  },
  {
    id: 'transmed',
    name: 'TransMed Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[3.0, 36.8], [8.0, 37.0], [10.0, 37.5], [12.5, 37.8], [14.2, 40.8]],
    capacity: '33.5 bcm/year',
    length: '2,475 km',
    operator: 'Sonatrach/Eni',
    countries: ['Algeria', 'Tunisia', 'Italy'],
  },

  // South America
  {
    id: 'bolivia-brazil',
    name: 'Bolivia-Brazil Pipeline (GASBOL)',
    type: 'gas',
    status: 'operating',
    points: [[-63.2, -17.8], [-60.0, -19.0], [-56.0, -21.0], [-50.0, -22.5], [-47.0, -23.5]],
    capacity: '30 mcm/day',
    length: '3,150 km',
    operator: 'TBG',
    countries: ['Bolivia', 'Brazil'],
  },
  {
    id: 'norandino',
    name: 'NorAndino Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[-63.8, -22.0], [-65.0, -23.5], [-66.0, -25.0], [-68.0, -24.3]],
    capacity: '8 mcm/day',
    length: '1,180 km',
    operator: 'NorAndino',
    countries: ['Argentina', 'Chile'],
  },
  {
    id: 'gasoducto-sur',
    name: 'Gasoducto del Sur',
    type: 'gas',
    status: 'operating',
    points: [[-68.5, -38.9], [-70.0, -40.5], [-71.5, -42.0], [-72.5, -45.0]],
    capacity: '12 mcm/day',
    length: '1,500 km',
    operator: 'TGS',
    countries: ['Argentina'],
  },
  {
    id: 'camisea',
    name: 'Camisea Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[-72.7, -11.8], [-74.0, -13.0], [-75.5, -13.5], [-77.0, -12.0]],
    capacity: '20 mcm/day',
    length: '730 km',
    operator: 'TGP',
    countries: ['Peru'],
  },
  {
    id: 'oleoducto-norperuano',
    name: 'Oleoducto Norperuano',
    type: 'oil',
    status: 'operating',
    points: [[-76.0, -4.5], [-78.0, -5.0], [-79.5, -5.2], [-80.5, -5.0]],
    capacity: '200,000 bpd',
    length: '854 km',
    operator: 'Petroperu',
    countries: ['Peru'],
  },
  {
    id: 'ocensa',
    name: 'OCENSA Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-72.0, 4.5], [-73.5, 5.5], [-74.5, 6.5], [-75.0, 8.0], [-75.5, 10.5]],
    capacity: '590,000 bpd',
    length: '830 km',
    operator: 'OCENSA',
    countries: ['Colombia'],
  },
  {
    id: 'cano-limon',
    name: 'Cano Limon Pipeline',
    type: 'oil',
    status: 'operating',
    points: [[-70.2, 6.8], [-71.5, 7.0], [-73.0, 8.5], [-74.8, 10.9]],
    capacity: '220,000 bpd',
    length: '780 km',
    operator: 'Ecopetrol',
    countries: ['Colombia'],
  },

  // Australia/Pacific
  {
    id: 'moomba-sydney',
    name: 'Moomba-Sydney Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[140.0, -28.1], [145.0, -31.0], [148.0, -33.0], [151.2, -33.9]],
    capacity: '14.6 bcm/year',
    length: '2,081 km',
    operator: 'APA Group',
    countries: ['Australia'],
  },
  {
    id: 'dampier-bunbury',
    name: 'Dampier-Bunbury Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[116.7, -20.7], [116.5, -24.0], [116.0, -28.0], [115.6, -33.3]],
    capacity: '32 bcm/year',
    length: '1,530 km',
    operator: 'DBP',
    countries: ['Australia'],
  },
  {
    id: 'eastern-gas-pipeline',
    name: 'Eastern Gas Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[147.0, -38.0], [148.5, -36.5], [150.0, -35.5], [151.2, -33.9]],
    capacity: '8.7 bcm/year',
    length: '795 km',
    operator: 'Jemena',
    countries: ['Australia'],
  },
  {
    id: 'roma-brisbane',
    name: 'Roma-Brisbane Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[148.8, -26.6], [150.0, -26.5], [152.0, -27.0], [153.0, -27.5]],
    capacity: '6 bcm/year',
    length: '440 km',
    operator: 'APA Group',
    countries: ['Australia'],
  },
  {
    id: 'south-west-qld-pipeline',
    name: 'South West Queensland Pipeline',
    type: 'gas',
    status: 'operating',
    points: [[141.5, -28.0], [144.0, -27.5], [147.0, -27.0], [149.0, -26.5]],
    capacity: '10 bcm/year',
    length: '937 km',
    operator: 'APA Group',
    countries: ['Australia'],
  },

];

/** Read a CSS custom property value from :root (cached per theme) */
function getCSSColor(varName: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
}

// Pipeline colors by type — fixed category colors (not theme-dependent)
export const PIPELINE_COLORS: Record<string, string> = {
  oil: '#ff6b35',
  gas: '#00b4d8',
  products: '#ffd166',
};

/** Get pipeline status color using semantic CSS variables */
export function getPipelineStatusColor(status: string): string {
  switch (status) {
    case 'operating': return getCSSColor('--status-live');
    case 'construction': return getCSSColor('--semantic-elevated');
    default: return getCSSColor('--text-dim');
  }
}

// Pipeline status colors — kept for backward compatibility (DeckGL RGB conversion)
export const PIPELINE_STATUS_COLORS: Record<string, string> = {
  operating: '#44ff88',
  construction: '#ffaa00',
};
